<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="admin-content">
      <div class="page-card-title">
        <span class="page-card-title-text">{{ $t('text.invite_user') }}</span>
      </div>
      <div class="page-card-content">
        <div class="mt-20 page-content">
          <InviteUser />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InviteUser from '@/components/manage/user/InviteUser'
export default {
  components: {
    InviteUser
  }
}
</script>
